import SwitcherModern from './SwitcherModern'

export default SwitcherModern
